/* eslint-disable no-unused-vars */
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Divider, Grid, LinearProgress, MenuItem, TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import { getUserData, setUserData } from '../../../../Utils/storages';
import { getAdminDetails, updateAdmin } from '../../../../Redux/Models/admin';
import { fetchClient } from '../../../../Utils/helpers';

export default function Component({
  classes, error, message, admin, isLoading, newAdmin,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = getUserData();
  const photoRef = useRef(null);

  const { openAlert } = useContext(AlertContext);

  const [submitted, setSubmitted] = useState(false);
  const [label, setLabel] = useState({
    gender: 'Choose gender',
    marital: 'Choose marital',
  });

  const [files, setFiles] = useState({
    photo: '',
    id_document: '',
  });

  const [personalData, setPersonalData] = useState({
    name: '',
    gender: '',
    marital_status: '',
    phone_number: '',
    email: '',
    address: '',
    city: '',
    state: '',
    country: '',
    postal_code: '',
    password: '',
    role: '',
  });
  const [documentData, setDocumentData] = useState({
    id_number: '',
  });

  useEffect(() => {
    dispatch(getAdminDetails(userData.id));
  }, []);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    if (admin.personal_data && !isLoading) {
      setPersonalData(admin.personal_data);
      setDocumentData({
        id_number: admin.document_data?.id_card,
      });
      setFiles({
        photo: admin.personal_data?.photo,
        id_document: admin.document_data?.id_document,
      });
    }
  }, [admin]);

  const handleOnFocus = (e) => {
    setLabel({
      ...label,
      [e.target.id]: '',
    });
  };

  const handleOnBlur = () => {
    setLabel({
      gender: 'Choose gender',
      marital: 'Choose marital',
    });
  };

  const handleChangeFiles = (name, url) => {
    setFiles({ ...files, [name]: url });
  };

  const handleChangePD = (e) => {
    setPersonalData({ ...personalData, [e.target.name]: e.target.value });
  };

  const handleChangeDD = (e) => {
    setDocumentData({ ...documentData, [e.target.name]: e.target.value });
  };

  const photoTrigger = (ref) => {
    ref?.current?.click();
  };

  const handleChangePhoto = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const acceptedExt = ['png', 'jpg', 'jpeg', 'gif'];
      const fileExt = file.name.split('.').reverse()[0];

      if (!acceptedExt.includes(fileExt?.toLowerCase())) {
        openAlert({ message: 'Sorry, You only can upload image file', severity: 'error', open: true });
        return;
      }

      const fileSize = file.size;
      if (fileSize > (10000 * 1000)) {
        openAlert({ message: 'Sorry, maximum file size is 10MB', severity: 'error', open: true });
        return;
      }

      openAlert({ message: 'Uploading...', severity: 'info', open: true });
      const body = new FormData();
      body.append('file', file);

      fetchClient({
        method: 'POST',
        url: '/upload',
        data: body,
      }).then((res) => {
        handleChangeFiles(e.target.name, res.data.data.url);
        openAlert({ message: 'Successfully upload...', severity: 'success', open: true });
      }).catch((err) => {
        openAlert({ message: err.response.data.message, severity: 'error', open: true });
      });
    }
  };

  const saveData = () => {
    setSubmitted(true);
    const body = {
      personal_data: {
        ...personalData,
        full_name: personalData.name,
        photo: files.photo,
        role: userData.role_id,
      },
      document_data: {
        ...documentData,
        id_document: files.id_document,
      },
    };

    dispatch(updateAdmin(body, userData.id));
  };

  useEffect(() => {
    if (error) {
      openAlert({
        open: true,
        severity: 'error',
        message: `Something went wrong, ${message}`,
      });
    }

    if (newAdmin && submitted) {
      openAlert({
        open: true,
        severity: 'success',
        message: 'Admin data updated',
      });
      setUserData({
        ...userData,
        profile_picture: files.photo,
      });
    }
  }, [submitted, error, newAdmin]);

  return (
    <Elements.AdminPageBase navigate={navigate}>
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>General Settings</strong>
          </Box>
        </Box>

        <Box mt={3} bgcolor="#FDFDFD" borderRadius="10px" border="1px solid #E5E5E5" px={3} py={2}>
          {isLoading && <LinearProgress color="inherit" sx={{ mb: 2 }} />}
          <Box fontWeight="600" mb={3}>Profile Information</Box>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box fontSize={14}>Profile Picture</Box>
              <input type="file" name="photo" hidden ref={photoRef} onChange={handleChangePhoto} />
              <Box display="flex" gap={3} mt={1}>
                <img src={files.photo} onClick={() => photoTrigger(photoRef)} alt="pp" className="cover circle" height="120" width="120" />
                <Box>
                  <Box color="#586479" fontSize={14}>Format .JPG or .PNG, Max 1Mb</Box>
                  <Button className="btn-outlined" variant="outlined" sx={{ mt: 0.5 }} size="small" onClick={() => photoTrigger(photoRef)}>Change Photo</Button>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box fontSize={14}>Name</Box>
              <TextField size="small" fullWidth sx={{ mt: 1 }} name="name" onChange={handleChangePD} value={personalData.name} />
            </Grid>
            <Grid item xs={6}>
              <Box fontSize={14}>Marital Status</Box>
              <TextField
                id="marital"
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                label={!personalData.marital_status ? label.marital : null}
                select
                fullWidth
                size="small"
                name="marital_status"
                onChange={handleChangePD}
                value={personalData.marital_status}
              >
                <MenuItem value="single">Single</MenuItem>
                <MenuItem value="married">Married</MenuItem>
                <MenuItem value="divorced">Divorced</MenuItem>
                <MenuItem value="-">Prefer not to say</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <Box fontSize={14}>Gender</Box>
              <TextField
                id="gender"
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                label={!personalData.gender ? label.gender : null}
                select
                fullWidth
                size="small"
                name="gender"
                onChange={handleChangePD}
                value={personalData.gender}
              >
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="-">Prefer not to say</MenuItem>
              </TextField>
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Box fontSize={14}>Phone Number</Box>
              <TextField placeholder="Type here" name="phone_number" onChange={handleChangePD} value={personalData.phone_number} fullWidth size="small" inputMode="numeric" />
            </Grid>
            <Grid item xs={6}>
              <Box fontSize={14}>Email</Box>
              <TextField autoComplete="new-password" placeholder="Type here" type="email" name="email" onChange={handleChangePD} disabled value={personalData.email} fullWidth size="small" inputMode="email" />
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          <Box display="flex" justifyContent="flex-end">
            <Button className="btn-contained" variant="contained" size="small" onClick={saveData}>Save new information</Button>
          </Box>
        </Box>
      </div>
    </Elements.AdminPageBase>
  );
}
